import { useEffect } from 'react';
import { track, trackOnce } from '../utils/productEvents';

/**
 * Records a product event when it mounts: once per `onceKey` per tab when a key
 * is given, otherwise on every mount. It is a component of its own so a parent
 * can render it from any branch, including one after an early return, without
 * adding a hook to the parent.
 */
export default function TrackEvent({ onceKey, name, props }) {
  useEffect(() => {
    if (onceKey) trackOnce(onceKey, name, props);
    else track(name, props);
    // Keyed on onceKey alone: props are a snapshot taken at mount.
  }, [onceKey]);
  return null;
}
